module.exports = __webpack_public_path__ + "img/header-navigation-below-ford.84316126.png";